import React from 'react'
import CompleteForm from './components/CompleteForm'
import Sidebar from '../Booking/components/Sidebar'
import { useSelector } from 'react-redux'

const AcceptPendingPayment = () => {
  const { dictionary, values } = window.modifyData
  const { pendingPayment } = values || {}
  const { type } = useSelector((state) => state.booking)

  const getType = () => {
    switch (type) {
      case 'pending':
        return dictionary.acceptPendingPaymentHeading
      case 'modify':
        return dictionary.acceptModificationHeading
      case 'cancel':
        return dictionary.acceptCancelationHeading
      default:
        return dictionary.acceptModificationHeading
    }
  }

  return (
    <div className="page-container s-modify-reservation">
      <h1 className="h1 m-0">{getType()}</h1>
      <div className="row">
        <div className="col-lg-7">
          <CompleteForm type={type} pendingPayment={pendingPayment} />
        </div>
        <div className="col-lg-4 offset-lg-1 d-none d-lg-block">
          <Sidebar />
        </div>
      </div>
    </div>
  )
}

export default AcceptPendingPayment
